import api from "./api";

const AppParamAPI = {
    getAll: () => api.get(`/public/application-params/all`),
    getAdminAll: () => api.get(`/admin/application-params/admin-all`),
    getById: (id) => api.get(`/admin/application-params/details/${id}`),
    update: (data) => api.post(`/admin/application-params/update`, data),
};

export default AppParamAPI;
